/**
 * Pulls a filename out of a Content-Disposition header. Tolerates quoted and
 * unquoted forms. Falls back to a client-built name in the same shape as the
 * server filename (capabilities-{site}-{yyyyMMdd-HHmmss}.csv) so the user gets
 * a sensible download name even if the server header is missing.
 */
export function extractFilenameFromContentDisposition(
  header: string | null | undefined,
  fallbackPlantCode: string
): string {
  if (header) {
    const match = header.match(/filename\*?=(?:UTF-8''|"|)([^";]+)"?/i);
    if (match && match[1]) {
      try {
        return decodeURIComponent(match[1]).replace(/^"|"$/g, "");
      } catch {
        return match[1].replace(/^"|"$/g, "");
      }
    }
  }
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, "0");
  const ts =
    now.getUTCFullYear().toString() +
    pad(now.getUTCMonth() + 1) +
    pad(now.getUTCDate()) +
    "-" +
    pad(now.getUTCHours()) +
    pad(now.getUTCMinutes()) +
    pad(now.getUTCSeconds());
  return `capabilities-${fallbackPlantCode}-${ts}.csv`;
}
